import type { ReactNode } from 'react';
import type { FormatOptionLabelMeta, StylesConfig } from 'react-select';
import Select from 'react-select';
import type { FilterOption } from '../model/types';

interface TaskFilterMultiSelectProps {
    label: string;
    options: FilterOption[];
    value: FilterOption[];
    onChange: (ids: number[]) => void;
    styles: StylesConfig<FilterOption, true>;
    formatOptionLabel?: (
        option: FilterOption,
        meta: FormatOptionLabelMeta<FilterOption>,
    ) => ReactNode;
    isSearchable?: boolean;
    className?: string;
    classNamePrefix?: string;
}

const TaskFilterMultiSelect = ({
    label,
    options,
    value,
    onChange,
    styles,
    formatOptionLabel,
    isSearchable = true,
    className = 'w-100',
    classNamePrefix,
}: TaskFilterMultiSelectProps) => (
    <div className="mb-3">
        <label className="form-label text-muted fs-12 mb-1">{label}</label>
        <Select<FilterOption, true>
            isMulti
            isClearable
            isSearchable={isSearchable}
            options={options}
            value={value}
            onChange={(next) => onChange(next.map((option) => option.value))}
            placeholder={label}
            className={className}
            classNamePrefix={classNamePrefix}
            styles={styles}
            formatOptionLabel={formatOptionLabel}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            menuShouldScrollIntoView={false}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
        />
    </div>
);

export default TaskFilterMultiSelect;
